import { PaymentFailed } from '$shared/components';
import { OTHER } from '$shared/constants/pages';
import { Button } from '$uikit';
import { Link } from 'react-router5';
import React, { useEffect } from 'react';
import { CurrencyEnum } from '$store/models';
import { useTranslator } from '$hooks';
import { statReachGoal } from '$utils';

export const TopUpFailed = () => {
  const t = useTranslator();

  useEffect(() => {
    statReachGoal('payment_failed');
    statReachGoal('top_up_failed');
  }, []);

  return (
    <PaymentFailed>
      <Link routeName={OTHER} routeParams={{ w: 'balance', currency: CurrencyEnum.EUR }}>
        <Button size="small">{t('top_up_failed_go_to_balance')}</Button>
      </Link>
    </PaymentFailed>
  );
};
